import React, { memo, useMemo } from 'react';

export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  required?: boolean;
  backgroundColor?: 'primary' | 'secondary';
}

export const FormInput: React.FC<FormInputProps> = memo(({
  label,
  required = false,
  backgroundColor = 'primary',
  className = '',
  ...props
}) => {
  const bgColor = useMemo(() => backgroundColor === 'primary' 
    ? 'var(--color-bg-primary)' 
    : 'var(--color-bg-secondary)', [backgroundColor]);

  const labelText = useMemo(() => `${label}${required ? ' *' : ''}`, [label, required]);

  return (
    <div>
      <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-text-secondary)' }}>
        {labelText}
      </label>
      <input
        {...props}
        required={required}
        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 transition-colors ${className}`}
        style={{
          backgroundColor: bgColor,
          borderColor: 'var(--color-border)',
          color: 'var(--color-text-primary)',
          '--tw-ring-color': 'var(--color-accent)',
          ...props.style
        } as React.CSSProperties}
      />
    </div>
  );
});

FormInput.displayName = 'FormInput';

